export const DISPLAY_REQUEST = "DISPLAY_REQUEST"
export const ACCEPT_REQUEST = "ACCEPT_REQUEST"
export const VERIFY_FACE = "VERIFY_FACE"
export const VERIFY_PIN = "VERIFY_PIN"
export const SELECT_AND_PAID = "SELECT_AND_PAID"